function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "s\\xEDmbolos",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "m-topo-n\\xE3o-logado",
  transform: "translate(-333.000000, -15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(333.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.260625,11.5304394 L14.851925,9.77777778 C13.817925,10.7234931 12.449525,11.323489 11,11.323489 C9.550475,11.323489 8.182075,10.7234931 7.148075,9.77777778 L1.739375,11.5304394 C0.783475,11.8411324 0,12.8970075 0,13.8772145 L0,18.3333333 L22,18.3333333 L22,13.8772145 C22,12.8970075 21.217625,11.8411324 20.260625,11.5304394 Z M20.166575,16.5509928 L1.833425,16.5509928 L1.833425,13.8772145 C1.833425,13.6630449 2.1109,13.2897855 2.32045,13.220802 L6.775725,11.7780313 C8.03605,12.6403247 9.501525,13.1060969 11,13.1060969 C12.49765,13.1060969 13.96395,12.6403247 15.22345,11.7780313 L19.680375,13.2218715 C19.8891,13.2897855 20.166575,13.6630449 20.166575,13.8772145 L20.166575,16.5509928 Z",
  id: "Combined-Shape",
  fill: "#BFC5D2",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#BFC5D2",
  strokeWidth: 2,
  cx: 11,
  cy: 4.27777778,
  r: 4.27777778
}))));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.8c350a4a.svg";
export { ForwardRef as ReactComponent };